import React, { Fragment } from "react";
import AppBar from "./AppBar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <Fragment>
      <AppBar />
      <main>{children}</main>
      <Footer />
    </Fragment>
  );
};

export default Layout;
